import { swalWithConfirmAndCancelButtons } from "components/custom/swal"
import React, { useEffect, useState } from "react"
import Loader from "react-loaders"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { Card, CardBody, Col, Container, Input, Label, Row } from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import { loadPageItem } from "store/actions"
import colors from "utils/colors"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import useModal from "hooks/useModalHook"
import EditRoleModal from "./EditRoleModal"

const ManageRoles = props => {
  const currentUser = userService.getLoggedInUser()
  const dispatch = useDispatch()
  const { pageItem } = useSelector(state => ({
    pageItem: state.pageItem.pageItem,
  }))
  const [isLoading, setIsLoading] = useState(false)
  const [roles, setRoles] = useState([])

  const [roleIdToEdit, setRoleIdToEdit] = useState(-1)
  const { show: showEditRoleModal, toggle: toggleEditRoleModal } = useModal()

  useEffect(() => {
    dispatch(
      loadPageItem({
        userId: currentUser.userID,
        scenarioId: 0,
        alternativeId: 0,
        viewName: "manageRoles",
      })
    )
    loadData()
  }, [])

  const loadData = async () => {
    setIsLoading(true)

    let r = await api.getRoles(currentUser.enterpriseID)
    setRoles(r)

    setIsLoading(false)
  }

  const addRole = () => {
    setRoleIdToEdit(-1)
    toggleEditRoleModal()
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={pageItem !== undefined ? pageItem.pageSubTitle : ""}
          />
          <Card>
            <CardBody>
              <button className={`btn btn-primary mb-3`} onClick={addRole}>
                + Add Role
              </button>
              <Row>
                <Col md="12">
                  {isLoading && (
                    <Loader
                      type="line-scale-pulse-out"
                      color={colors.primary}
                      style={{ textAlign: "center" }}
                    />
                  )}
                  <table
                    className="table table-bordered low-padding-table"
                    style={{ backgroundColor: "white" }}
                  >
                    <thead>
                      <tr>
                        <th>Role</th>
                      </tr>
                    </thead>
                    <tbody>
                      {roles.map((role, index) => (
                        <tr key={index}>
                          <td>
                            <a
                              href="#"
                              onClick={() => {
                                setRoleIdToEdit(role.roleID)
                                toggleEditRoleModal()
                              }}
                            >
                              {role.roleName}
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
      <EditRoleModal
        isOpen={showEditRoleModal}
        toggleModal={toggleEditRoleModal}
        roleIdToEdit={roleIdToEdit}
        reload={loadData}
      />
    </React.Fragment>
  )
}

export default ManageRoles
